import { all, fork } from 'redux-saga/effects';
import {
  watchFetchNotificationSettings,
  watchForgotPasswordReset,
  watchForgotPasswordSendCode,
  watchUpdateNotificationSettings,
} from './accountSaga';
import {
  watchPostFeedbackTempmee,
  watchFeedbackSave,
  watchfeedbackRequired,
  watchFetchUserProcedureEndorsement,
  watchSaveNpsReview,
  watchSendProcedureEndorsement,
} from './engagementSaga';
import {
  watchAcceptPSATerms,
  watchAcceptTerms,
  watchFetchMetadata,
  watchGetAllProfessionals,
  watchGetAllSoftwares,
  watchGetAllSpecializations,
  watchGetOfficeEducation,
  watchGetUserEducation,
  watchUpdateUserEducation,
} from './metadataSaga';
import {
  watchGetChildOffices,
  watchOfficeSelect,
  watcSearchChildOffice,
} from './officeSaga';
import {
  watchBlockProfessional,
  watchBlockRecentProfessional,
  watchFetchProfessionalProfile,
} from './professionalsSaga';
import {
  watchCloseModalWithCode,
  watchEditUser,
  watchEditUserAccountInfo,
  watchEditUserGeneralInfo,
  watchEditUserOfficeInfo,
  watchPhoneVerification,
  watchUploadAvatar,
} from './profileSaga';
import {
  watchConfirmReferralPayout,
  watchCreateReferralLink,
  watchFetchPartnershipOrganizations,
  watchGetReferralList,
  watchGetReferralPayouts,
  watchGetReferralSummary,
  watchLinkReferralAccount,
  watchSaveGiftEmail,
  watchVerifyPartnershipCode,
} from './referralSaga';
import {
  watchAuthLogout,
  watchInitialLoading,
  watchSignIn,
  watchSignUP,
} from './sessionSaga';
import {
  watchGetStateWorkerClassification,
  watchGetWorkerClassificationManagement,
  watchSaveChildWorkerClassification,
  watchSaveStatusChildWorkerClassification,
  watchSaveWorkerClassification,
} from './workerClassificationSaga';

// use them in parallel
export default function* sagaAuth() {
  yield all([
    fork(watchInitialLoading),
    fork(watchSignIn),
    fork(watchSignUP),
    fork(watchAuthLogout),
    fork(watchEditUserAccountInfo),
    fork(watchEditUserGeneralInfo),
    fork(watchPhoneVerification),
    fork(watchCloseModalWithCode),
    fork(watchEditUserOfficeInfo),
    fork(watchEditUser),
    fork(watchBlockProfessional),
    fork(watchfeedbackRequired),
    fork(watchFeedbackSave),
    fork(watchSendProcedureEndorsement),
    fork(watchFetchUserProcedureEndorsement),
    fork(watchSaveNpsReview),
    fork(watchPostFeedbackTempmee),
    fork(watchOfficeSelect),
    fork(watcSearchChildOffice),
    fork(watchGetAllProfessionals),
    fork(watchSaveGiftEmail),
    fork(watchCreateReferralLink),
    fork(watchGetAllSpecializations),
    fork(watchGetUserEducation),
    fork(watchGetOfficeEducation),
    fork(watchUpdateUserEducation),
    fork(watchGetAllSoftwares),
    fork(watchAcceptTerms),
    fork(watchAcceptPSATerms),
    fork(watchFetchNotificationSettings),
    fork(watchUpdateNotificationSettings),
    fork(watchFetchPartnershipOrganizations),
    fork(watchVerifyPartnershipCode),
    fork(watchFetchMetadata),
    fork(watchSaveWorkerClassification),
    fork(watchGetStateWorkerClassification),
    fork(watchGetWorkerClassificationManagement),
    fork(watchSaveChildWorkerClassification),
    fork(watchSaveStatusChildWorkerClassification),
    fork(watchForgotPasswordSendCode),
    fork(watchForgotPasswordReset),
    fork(watchUploadAvatar),
    fork(watchBlockRecentProfessional),
    fork(watchGetChildOffices),
    fork(watchGetReferralList),
    fork(watchGetReferralSummary),
    fork(watchGetReferralPayouts),
    fork(watchConfirmReferralPayout),
    fork(watchLinkReferralAccount),
    fork(watchFetchProfessionalProfile),
  ]);
}
